import { useEffect, useState } from "react";
import type { FormEvent } from "react";
import { Loader2, Plus, Save, X } from "lucide-react";
import type {
  CalidadControlModificacion,
  CalidadControlModificacionPayload,
} from "../../types/control-modificaciones";

type Props = {
  open: boolean;
  mode: "create" | "edit";
  initialValues: CalidadControlModificacion | null;
  submitting: boolean;
  error: string | null;
  onClose: () => void;
  onSubmit: (payload: CalidadControlModificacionPayload) => void;
};

export function CalidadControlModificacionFormModal({
  open,
  mode,
  initialValues,
  submitting,
  error,
  onClose,
  onSubmit,
}: Props) {
  const [fecha, setFecha] = useState("");
  const [modificaciones, setModificaciones] = useState("");

  useEffect(() => {
    if (open) {
      setFecha(initialValues?.fecha ?? "");
      setModificaciones(initialValues?.modificaciones_realizadas ?? "");
    }
  }, [initialValues, open]);

  if (!open) {
    return null;
  }

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit({
      fecha: fecha.trim(),
      modificaciones_realizadas: modificaciones.trim(),
    });
  };

  return (
    <div className="reqleg-modal-backdrop" role="dialog" aria-modal="true">
      <form className="reqleg-control-modal" onSubmit={handleSubmit}>
        <div className="reqleg-modal-header">
          <div>
            <div className="calidad-section-eyebrow">
              {mode === "create" ? "Nueva modificación" : "Editar modificación"}
            </div>
            <h3 className="reqleg-modal-title">Control documental</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="reqleg-modal-close"
            aria-label="Cerrar"
          >
            <X size={18} />
          </button>
        </div>

        {error ? <div className="reqleg-inline-error">{error}</div> : null}

        <div className="reqleg-form-grid reqleg-control-form-grid">
          <label className="reqleg-field">
            <span>Fecha</span>
            <input
              value={fecha}
              onChange={(event) => setFecha(event.target.value)}
              placeholder="Ej. 01/2025"
              required
            />
          </label>

          <label className="reqleg-field reqleg-field-span-2">
            <span>Modificaciones realizadas</span>
            <textarea
              value={modificaciones}
              onChange={(event) => setModificaciones(event.target.value)}
              rows={5}
              required
            />
          </label>
        </div>

        <div className="reqleg-modal-actions">
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="calidad-back-button"
          >
            Cancelar
          </button>
          <button type="submit" disabled={submitting} className="calidad-primary-button">
            {submitting ? (
              <Loader2 size={16} className="animate-spin" />
            ) : mode === "create" ? (
              <Plus size={16} />
            ) : (
              <Save size={16} />
            )}
            {mode === "create" ? "Crear" : "Guardar"}
          </button>
        </div>
      </form>
    </div>
  );
}
